// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"hD-z","smallCardRow":"iD-z","largeCardRow":"jD-z","productSearchRow":"kD-z","curatedRow":"lD-z"};